/**
 * Decides whether a failed API response should advance to the next step
 * in the verification fallback chain (createContact -> Experian -> manual lead).
 *
 * Rules:
 *   - 422 is a semantic "rejected" outcome (callers map it to the rejected
 *     route) and must NOT trigger a fallback.
 *   - All other 4xx responses fall back.
 *   - All 5xx responses fall back (treated as transient/provider errors;
 *     try the next provider in the chain).
 *   - Missing/unknown codes (e.g. network errors with no response) do not
 *     fall back; the caller will surface the error inline.
 */
export const REJECTED_STATUS_CODE = 422;

export const shouldFallback = (code: number | undefined): boolean => {
  if (typeof code !== 'number') return false;
  if (code === REJECTED_STATUS_CODE) return false;
  return code >= 400 && code < 600;
};
